import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'tf-date-time-input',
  standalone: true,
  imports: [FormsModule, DatePickerModule],
  template: `
    <p-datepicker
      [inputId]="inputId()"
      [placeholder]="placeholder()"
      [ngModel]="dateValue()"
      (ngModelChange)="onDateChange($event)"
      [showTime]="true"
      appendTo="body"
      [invalid]="invalid()"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateTimeInputComponent {
  readonly value = input<string>('');
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-date-time-input');
  readonly invalid = input<boolean>(false);
  @Output() readonly valueChange = new EventEmitter<string>();

  readonly dateValue = computed<Date | null>(() => {
    const str = this.value();
    if (!str || str === '') return null;
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  });

  onDateChange(date: Date | null): void {
    this.valueChange.emit(date ? date.toISOString() : '');
  }
}
